<template>
  <div class="dashboard">
    <div class="container">
      <h6>Projects</h6>

      <div class="card" v-for="project in projects" :key="project.id">
        <div class="details">
          <span class="title">{{ project.title }}</span>
          <!-- <span class="right"> ksh .00</span> -->
        </div>
        <div class="action savings">
          <a :href="project.link" class="material-icons-outlined button"
            >link</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/reactivity";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const projects = computed(() => {
      return store.state.projects;
    });
    return {
      projects,
    };
  },
};
</script>

<style>
.dashboard {
  min-height: 100vh;
  margin-top: 55px;
  margin-bottom: 55px;
}
h6 {
  padding: 10px;
}
.card {
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 23fr 1fr;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 4px 2px;
}
.details {
  padding: 15px;
  font-weight: 600;
}
.button {
  font-size: 22px;
  color: #fff;
  padding: 15px;
}
.title {
  opacity: 0.9;
}
.action {
  float: right;
}

.savings {
  background-color: rgb(160, 114, 245);
}

.dark {
  background-color: #333;
  color: #fff;
}
.dark .button {
  color: #fff;
}
</style>
